import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { Arrow } from './Arrow';

import global from '../../stores/GlobalStore';

export default class UserFollows extends React.Component {
  constructor(props) {
    super(props);

    this.PodcastStore = global().getPodcastStore();

    this.state = {
      isLoading: true,
      shows: {},
    };
  }

  componentDidMount() {
    if (!_.size(this.state.shows) && this.props.userId) {
      this.PodcastStore.fetchUserFollowedShows(this.props.userId, shows => {
        this.setState({ shows, isLoading: false });
      });
    }
  }

  render() {
    const { shows } = this.state;
    const ArrowLeft = Arrow({ text: 'left', className: 'arrow-prev' });
    const ArrowRight = Arrow({ text: 'right', className: 'arrow-next' });

    return (
      !!_.size(shows) && (
        <div className='show-list my-shows'>
          <div className='my-shows'>
            <div className='shows-header'>My Shows</div>
            <ScrollMenu
              data={this.props.renderShows(shows)}
              arrowLeft={ArrowLeft}
              arrowRight={ArrowRight}
              onSelect={this.props.navToShow}
              transition={0.8}
              alignCenter={false}
              wheel={false}
              scrollBy={2}
              hideArrows={true}
              hideSingleArrow={true}
            />
          </div>
        </div>
      )
    );
  }
}

UserFollows.propTypes = {
  userId: PropTypes.string.isRequired,
  renderShows: PropTypes.func.isRequired,
  navToShow: PropTypes.func.isRequired,
};
